import CosechaRepository from '@/services/CosechaRepository'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    listaRendimientoCosecha: [],
  },
  getters: {
    getRendimientoCosecha: (state) => (idRendimientoCosecha) => {
      return state.listaRendimientoCosecha.find(rendimientoCosecha => rendimientoCosecha.idRendimientoCosecha === idRendimientoCosecha)
    },
  },
  mutations: {
    setListaRendimientoCosecha(state, listaRendimientoCosecha) {
      state.listaRendimientoCosecha = listaRendimientoCosecha.map(rendimientoCosecha => {
        rendimientoCosecha.fechaFormated = Vue.filter('fhDate')(rendimientoCosecha.fecha)
        return rendimientoCosecha
      })
    },

    clearRendimientoCosecha(state) {
      state.listaRendimientoCosecha = []
    },
  },
  actions: {
    async fetchListaRendimientoCosecha({state, commit, rootState}) {
      if (state.listaRendimientoCosecha && state.listaRendimientoCosecha.length > 0) {
        return
      }

      let idFichaAgricola = rootState.fichas.fichaAgricola.idFichaAgricola

      let listaRendimientoCosecha = await CosechaRepository.listaRendimientoCosecha(idFichaAgricola) || []
      commit('setListaRendimientoCosecha', listaRendimientoCosecha)
    },

    clearRendimientoCosecha({commit}) {
      commit('clearRendimientoCosecha')
    },
  }
}
